"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgInSearch = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgInSearch = function SvgInSearch(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.8599 15.184L11.9717 11.2958C13.0147 10.0967 13.6462 8.53215 13.6462 6.82217C13.6462 3.05809 10.5845 0 6.824 0C3.05992 0 0.00183105 3.06164 0.00183105 6.82217C0.00183105 10.5827 3.06347 13.6443 6.824 13.6443C8.53398 13.6443 10.0985 13.0129 11.2976 11.9698L15.1859 15.8581C15.2781 15.9503 15.4023 16 15.5229 16C15.6435 16 15.7677 15.9539 15.8599 15.8581C16.0444 15.6736 16.0444 15.3685 15.8599 15.184ZM0.956155 6.82217C0.956155 3.5867 3.58853 0.957871 6.82046 0.957871C10.0559 0.957871 12.6848 3.59024 12.6848 6.82217C12.6848 10.0541 10.0559 12.69 6.82046 12.69C3.58853 12.69 0.956155 10.0576 0.956155 6.82217Z",
    fill: "currentColor"
  }));
};

exports.SvgInSearch = SvgInSearch;